import Vue from 'vue';
// import store from '@/store';
import { idToken } from '@/utils/auth/';

Vue.prototype.$authorizedFetch = async (url, options) => {
  const opts = options || {};
  const token = await idToken();
  opts.headers = opts.headers || {};
  // Set fetch mode to cors to allow 'Authorization' header in FETCH request
  opts.mode = 'cors';
  opts.headers.Authorization = `Bearer ${token}`;
  return fetch(url, opts);
};
